export type AppLayoutMode = 'default' | 'pos' | 'workspace';

const posRoutes = new Set([
  '/sale-register',
  '/quotation-register',
  '/cash/pending-sales',
]);

const workspaceRoutes = new Set([
  '/sale-history',
  '/quotation-history',
  '/reports/dte-bulk-download',
]);

const matchesRoute = (pathname: string, routes: Set<string>) =>
  Array.from(routes).some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

export const getAppLayoutMode = (pathname: string): AppLayoutMode => {
  if (matchesRoute(pathname, posRoutes)) return 'pos';

  if (pathname === '/restaurant' || pathname.startsWith('/restaurant/')) {
    return 'workspace';
  }

  if (matchesRoute(pathname, workspaceRoutes)) return 'workspace';

  return 'default';
};
